module.exports = __webpack_public_path__ + "coin_EUR.svg?2903db48e3ab0651a7e9ff2d445e71c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_EUR.svg
// module id = 1136
// module chunks = 2